// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"582dc80b233d1e8994af","293":"fbf9c816c34ffa4c10ce"}[chunkId] + ".js";
};